import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { oktaAuthentication } from '../../logic/store/User/AuthSlice';
import { useAppDispatch, useAppSelector } from '../../logic/store/Store';
import * as queryString from 'query-string';
import { POST_LOGIN_REDIRECT_KEY } from '../Routing/authRedirect';

/**
 * Handles the OAuth callback from Okta after user authentication.
 * Parses the authorization code from URL parameters and exchanges it for tokens.
 * Redirects to /dashboard on success or /login on failure.
 */
export const OktaHandler = (_props: {}) => 
{
	const dispatch = useAppDispatch();
	const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
	const history = useHistory();

	useEffect(() => 
	{
		async function execute() 
		{
			try 
			{
				const parsed = queryString.parse(location.search);
				const errorValue = parsed.error;
				if(errorValue && typeof errorValue === 'string' && errorValue.length > 0)
				{
					history.push('/login?error=' + encodeURIComponent(`Login failed: ${parsed.error_description}`));
					return;
				}

				const code = parsed.code as string;
				if(code?.length)
				{
					const state = parsed.state as string;
					const authResult = await dispatch(oktaAuthentication({ code, state }));
					if(authResult && authResult.type === oktaAuthentication.rejected.type)
					{
						history.push('/login?error=' + encodeURIComponent(`Login failed: ${authResult.payload}`));
						return;
					}

					// Don't navigate here - we defer navigation until isAuthenticated state updates
					// This prevents race conditions with the authentication state propagation
				}
				else
				{
					// Not a login redirect, perhaps show an error or redirect to login
					history.push('/login');
				}
			
			}
			catch (err) 
			{
				console.error('Okta authentication error:', err);
				history.push('/login?error=' + encodeURIComponent(err.message ?? 'An unknown error occurred'));
			}
		}
		execute();
	}, [dispatch, history]);

	useEffect(() => 
	{
		if(isAuthenticated)
		{
			// Check for a post-login redirect URL
			const redirectUrl = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
			if (redirectUrl)
			{
				// Remove it from storage and navigate
				localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
				history.replace(redirectUrl);
				return;
			}

			history.replace('/dashboard');
		}
	}, [isAuthenticated]);

	return <></>;
};
